<template>
  <div class="ac-card-content">
    <div class="ac-body-container">
      <img
        src="@shared/assets/img/logo/smart-maintenance-grey.png"
        class="ac-logo"
        alt="Smart Maintenance®"
      >
      <div class="ac-header">
        Smart Maintenance® Plan Details
      </div>
      <div class="ac-plan-container">
        <div class="ac-plan-header">
          <img
            src="@shared/assets/img/setting/hvac-icon.svg"
            alt="Comfort Credits"
          >
          System Inspections
        </div>
        <div class="margin-bottom-12 flex-column align-center">
          <div class="ac-plan-body-header">
            Virtual:
          </div>
          <div class="ac-plan-body">
            Partner will use the SmartAC.com dashboard to remotely
            review system performance and communicate those findings
            to the homeowner via text, email or video.
          </div>
        </div>
        <div class="margin-bottom-12 flex-column align-center">
          <div class="ac-plan-body-header">
            In person:
          </div>
          <div class="ac-plan-body">
            Partner will visit the home and perform a traditional
            seasonal maintenance call.
          </div>
        </div>
        <div class="ac-plan-body-header">
          Flex/Floating:
        </div>
        <div class="ac-plan-body">
          Partner will proactively monitor system performance
          through the SmartAC.com dashboard and will visit the
          home only when an issue (or potential issue) is detected.
        </div>
      </div>
      <button
        class="ac-button"
        @click="close"
      >
        Cancel
      </button>
    </div>
  </div>
</template>

<script>
export default {
  name: 'SystemInspectionInfo',
  props: {
    close: Function,
  },
};
</script>
